import { paths, API_URL } from "../config/endpoints";

export const isTokenExpired = (token: string | null): boolean => {
  if (!token) return true; // If no token, consider it expired

  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const decodedToken = JSON.parse(atob(base64));
    const exp = decodedToken.exp;

    if (!exp) throw new Error("Token does not have an expiration field");

    return Date.now() >= exp * 1000; // Check if the current time is past the expiration time
  } catch (error) {
    console.error("Failed to decode token or invalid format", error);
    return true; // Assume expired if error occurs
  }
};

export const refreshToken = async (): Promise<string> => {
  const storedRefreshToken = localStorage.getItem("refreshToken");

  if (!storedRefreshToken) {
    console.error("No refresh token found in local storage");
    throw new Error("No refresh token available");
  }

  try {
    // Construct the correct API URL
    const refreshUrl = `${API_URL}/${paths.guest}/${paths.auth}/${paths.refresh}`;

    const response = await fetch(refreshUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh_token: storedRefreshToken }), // Backend requires `refresh_token`
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      console.error("Failed to refresh token:", errorDetails);
      throw new Error(errorDetails.message || "Failed to refresh token");
    }

    const data = await response.json();
    const { token, refresh_token: newRefreshToken } = data;

    if (!token || !newRefreshToken) {
      console.error("Incomplete refresh token response:", data);
      throw new Error("Invalid refresh token response");
    }

    // Save new tokens in local storage
    localStorage.setItem("token", token);
    localStorage.setItem("refreshToken", newRefreshToken);

    return token;
  } catch (error) {
    console.error("Error during token refresh:", error);
    throw error;
  }
};
